import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

/**
 * Format date to IST (Indian Standard Time)
 */
export const formatToIST = (
  date: string | Date,
  formatString: string = 'dd MMM yyyy, hh:mm a'
): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    const istDate = toZonedTime(dateObj, 'Asia/Kolkata');
    return format(istDate, formatString);
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid date';
  }
};

/**
 * Get relative time (e.g., "2 hours ago")
 */
export const getRelativeTime = (date: string | Date): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    return formatDistanceToNow(dateObj, { addSuffix: true });
  } catch (error) {
    console.error('Relative time error:', error);
    return '';
  }
};

/**
 * Format date for display
 */
export const formatDate = (date: string | Date, formatString: string = 'PPP'): string => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    return format(dateObj, formatString);
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid date';
  }
};

/**
 * Check if date is today
 */
export const isToday = (date: string | Date): boolean => {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    const today = new Date();
    return (
      dateObj.getDate() === today.getDate() &&
      dateObj.getMonth() === today.getMonth() &&
      dateObj.getFullYear() === today.getFullYear()
    );
  } catch (error) {
    return false;
  }
};

/**
 * Get IST timezone offset
 */
export const getISTOffset = (): string => {
  return '+05:30';
};

/**
 * Convert UTC to IST
 */
export const utcToIST = (utcDate: string | Date): Date => {
  const dateObj = typeof utcDate === 'string' ? parseISO(utcDate) : utcDate;
  return toZonedTime(dateObj, 'Asia/Kolkata');
};